module.exports = require("@bechtel/client-assets/dist/images/under-construction.svg");